import { render, staticRenderFns } from "./xiaoweiFigureList.vue?vue&type=template&id=01205d70"
import script from "./xiaoweiFigureList.vue?vue&type=script&lang=js"
export * from "./xiaoweiFigureList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports